import Entity from '../entity'

export default class CourtReview extends Entity<number> {
    designStars: number = 0;
    installationStars: number = 0;
    serviceStars: number = 0;
    lawnStars: number = 0;
    content: string = "";
    courtId: number = 0;
    creatorUserId: number = 0;
    creationTime: Date;
}